import { render, staticRenderFns } from "./CustomBiSectionPage.vue?vue&type=template&id=6af481d2"
import script from "./CustomBiSectionPage.vue?vue&type=script&lang=ts"
export * from "./CustomBiSectionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports